module.exports = __webpack_public_path__ + "static/media/engineirpd2.b7c6474c.svg";